import { api, ApiError } from "@/lib/api";
import { useSession } from "@/lib/auth-client";
import { useQuery, useQueryClient } from "@tanstack/react-query";

// The org's models (defaults, the enabled list, its own endpoints), shared by
// the org Models page, Manage models and a Boo's Models tab.
export function useOrgModels(opts: { enabled?: boolean } = {}) {
  const { data: session } = useSession();
  const orgId = session?.session.activeOrganizationId;
  const query = useQuery({
    queryKey: ["org-models", orgId],
    queryFn: api.models.org,
    enabled: !!orgId && opts.enabled !== false,
    retry: (count, err) => !(err instanceof ApiError && err.status === 403) && count < 2,
  });
  return { orgId, ...query };
}

// Anything that lists models: after a model is turned on or off or an
// endpoint changes, every picker refreshes.
export function useInvalidateModels() {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: ["org-models"] }),
      queryClient.invalidateQueries({ queryKey: ["boo-model-catalog"] }),
      queryClient.invalidateQueries({ queryKey: ["boo-models"] }),
    ]);
}
